import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { AdresTypes } from "../../../constants/DomainConstants";
import AdresOverzichtForm from "./AdresOverzichtForm";
import AdresEditForm from "./AdresEditForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import AdresOverzichtPageHelper from "./AdresOverzichtPageHelper";
import * as layoutActions from "../../../actions/layoutActions";
import { throwException } from "../../../actions/exceptionActions";
import * as sessionActions from "../../../actions/sessionActions";
import redirector from "../../../util/redirector";

class AdresOverzichtPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: { adressen: [] },
            errors: {},
            originalModel: null,
            ondernemingsnummer: null,
            gebruikersnaam: null,
            sortedTable: null,
            transactieId: null,
            undoButtonDisabled: true,
            editMode: false,
            editingAdres: {},

            landen: [],
            adresTypes: [],
            beschrCorrespAdressen: [],
            postcodes: [],
            gemeenten: [],
            postcodeGemeenten: [],
            straten: [],
            huisnummers: null, //null means no data retrieved from Partner, empty array means no elements found
            busnummers: null, //null means no data retrieved from Partner, empty array means no elements found

            showUnknownToPartnerModal: false,
            showUnsavedChangesAdresModal: false,
            hasUnsavedChangesAdresEdit: false,
            hasUnsavedChanges: false
        };

        this.pageHelper = new AdresOverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        this.props.setHasUnsavedChanges(false);
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnSortTable = (index, event) => this.pageHelper.sortTable(index, event);
    handleOnSave = (event) => this.pageHelper.save(event);
    handleOnUndo = (event) => this.pageHelper.undo(event);
    handleOnDeleteAdres = (index, event) => this.pageHelper.deleteAdres(index, event);

    handleOnClickEdit = (index) => this.pageHelper.onClickEdit(index);
    handleOnClickSaveEdit = () => this.pageHelper.onClickSaveEdit();
    handleOnClickCancel = () => this.pageHelper.onClickCancel();

    handleOnChangeAdresField = (event) => this.pageHelper.onChangeAdresField(event);

    handleConfirmUnknownAdres = () => this.pageHelper.confirmUnknownAdres();
    handleCloseUnknownAdresModal = () => this.pageHelper.closeUnknownAdresModal();

    handleConfirmUnsavedChangesAdresEdit = () => this.pageHelper.confirmUnsavedChangesAdresEdit();
    handleCloseUnsavedChangesAdresEditModal = () => this.pageHelper.closeUnsavedChangesAdresEditModal();

    render() {
        const state = this.state;
        const props = this.props;
        const model = state.model;
        const editingAdres = state.editingAdres;
        const disabled = props.disabled;

        return (
            state.editMode ?
                <AdresEditForm
                    model={editingAdres}
                    errors={state.errors}
                    onSave={this.handleOnClickSaveEdit}
                    onCancel={this.handleOnClickCancel}
                    onChange={this.handleOnChangeAdresField}

                    landen={props.landen}
                    postcodeGemeenten={props.postcodeGemeenten}
                    straten={state.straten}
                    huisnummers={state.huisnummers}
                    busnummers={state.busnummers}

                    adresTypes={props.adresTypes}
                    beschrCorrespAdressen={props.beschrCorrespAdressen}
                    showUnknownToPartnerModal={state.showUnknownToPartnerModal}
                    showUnsavedChangesAdresModal={state.showUnsavedChangesAdresModal}
                    confirmUnknownAdres={this.handleConfirmUnknownAdres}
                    confirmUnsavedChangesAdresEdit={this.handleConfirmUnsavedChangesAdresEdit}
                    closeUnknownAdresModal={this.handleCloseUnknownAdresModal}
                    closeUnsavedChangesAdresEditModal={this.handleCloseUnsavedChangesAdresEditModal}
                    modelContainsMaatschappelijkeZetel={model.adressen.filter(x => !x.toDelete).some(x => x.soortAdres === AdresTypes.MAATSCHAPPELIJKE_ZETEL)}
                /> :
                <AdresOverzichtForm
                    model={model}
                    errors={state.errors}
                    onSortTable={this.handleOnSortTable}
                    onDelete={this.handleOnDeleteAdres}
                    onClickEdit={this.handleOnClickEdit}
                    onClickCancel={this.handleOnClickCancel}
                    onSave={this.handleOnSave}
                    onUndo={this.handleOnUndo}
                    undoButtonDisabled={this.state.undoButtonDisabled}
                    disabled={disabled}
                    landen={props.landen}
                    beschrCorrespAdressen={props.beschrCorrespAdressen}
                    adresTypes={props.adresTypes}
                    userType={props.userType}
                />);
    }
}

AdresOverzichtPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    return {
        ondernemingsnummer: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.ondernemingsnummer: null,
        gebruikersnaam: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.gebruikersnaam: null,
        transactieId: state.session.activeTransactionId,
        disabled: state.session.readOnly,
        gemeenten: state.referentie.gemeenten,
        postcodes: state.referentie.postcodes,
        postcodeGemeenten: state.referentie.postcodeGemeenten,
        landen: state.referentie.landen,
        adresTypes: state.referentie.adresTypes,
        beschrCorrespAdressen: state.referentie.beschrCorrespAdressen,
        isNew: state.session.isNew,
        userType: state.session.userType
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
        disableTopNav: bindActionCreators(layoutActions.disableTopNav, dispatch),
        enableTopNav: bindActionCreators(layoutActions.enableTopNav, dispatch),
        setActiveTransaction: bindActionCreators(sessionActions.setActiveTransactionId, dispatch),
        setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdresOverzichtPage);